// apps/web/src/routes/conversation-detail.tsx
import { useParams } from 'react-router-dom'
import { ConversationSidebar } from '../components/conversation-sidebar'
import { MessageList } from '../components/message-list'
import { MessageInput } from '../components/message-input'

export function ConversationDetailPage() {
  const { id } = useParams<{ id: string }>()
  if (!id) return null

  return (
    <div className="flex h-full">
      <ConversationSidebar />
      <div className="flex flex-1 flex-col">
        <MessageList conversationId={id} />
        <MessageInput conversationId={id} />
      </div>
    </div>
  )
}
